import { Type } from 'class-transformer';
import { ViolationHistoryImageResultDto } from './violation-history-image-result-dto';

export class ViolationHistoryResultDto {
  violationStatus: string;
  inspectStatus: string;
  regarding: string;
  noticeUrl: string;
  noticeFileName: string;
  inspectDate: Date;
  printClass: string;
  @Type(() => ViolationHistoryImageResultDto)
  images: ViolationHistoryImageResultDto[];
}
